export const STICKER_PACKS = [
    {
        id: 'parnishka',
        title: 'Парнишка',
        thumb: '/stickers/parnishka/thumb.webp',
        stickers: [
            {
                id: 'like',
                src: '/stickers/parnishka/like.webm',
                label: 'Лайк'
            },
            {
                id: 'cool',
                src: '/stickers/parnishka/cool.webm',
                label: 'Круто'
            },
            {
                id: 'think',
                src: '/stickers/parnishka/think.webm',
                label: 'Думаю'
            },
            {
                id: 'fire',
                src: '/stickers/parnishka/fire.webm',
                label: 'Огонь'
            },
            {
                id: 'coffee',
                src: '/stickers/parnishka/coffee.webm',
                label: 'Кофе'
            },
            {
                id: 'cool-static',
                src: '/stickers/parnishka/cool-static.webp',
                label: 'Круто'
            },
            {
                id: 'like-static',
                src: '/stickers/parnishka/like-static.webp',
                label: 'Лайк'
            },
            {
                id: 'think-static',
                src: '/stickers/parnishka/think-static.webp',
                label: 'Думаю'
            },
            {
                id: 'coffee-static',
                src: '/stickers/parnishka/coffee-static.webp',
                label: 'Кофе'
            },
            {
                id: 'fire-static',
                src: '/stickers/parnishka/fire-static.webp',
                label: 'Огонь'
            }
        ]
    },
    {
        id: 'komochek',
        title: 'Комочек',
        thumb: '/stickers/komochek/thumb.svg',
        stickers: [
            { id: 'hi', src: '/stickers/komochek/hi.svg', label: 'Привет' },
            { id: 'love', src: '/stickers/komochek/love.svg', label: 'Любовь' },
            { id: 'lol', src: '/stickers/komochek/lol.svg', label: 'Смех' },
            { id: 'wow', src: '/stickers/komochek/wow.svg', label: 'Вау' },
            { id: 'sad', src: '/stickers/komochek/sad.svg', label: 'Грусть' },
            { id: 'angry', src: '/stickers/komochek/angry.svg', label: 'Злость' },
            { id: 'ok', src: '/stickers/komochek/ok.svg', label: 'Ок' },
            { id: 'sleep', src: '/stickers/komochek/sleep.svg', label: 'Сон' }
        ]
    },
    {
        id: 'office',
        title: 'Офис',
        thumb: '/stickers/office/thumb.svg',
        stickers: [
            { id: 'coffee', src: '/stickers/office/coffee.svg', label: 'Кофе' },
            { id: 'rocket', src: '/stickers/office/rocket.svg', label: 'Поехали' },
            { id: 'done', src: '/stickers/office/done.svg', label: 'Готово' },
            { id: 'folder', src: '/stickers/office/folder.svg', label: 'Папка' },
            { id: 'idea', src: '/stickers/office/idea.svg', label: 'Идея' },
            { id: 'clock', src: '/stickers/office/clock.svg', label: 'Срок' },
            { id: 'fire', src: '/stickers/office/fire.svg', label: 'Огонь' },
            { id: 'trophy', src: '/stickers/office/trophy.svg', label: 'Победа' }
        ]
    }
];

export const isAnimatedSticker = sticker =>
    /\.webm($|\?)/i.test(String(sticker?.src || ''));

export const findSticker = key => {
    const [packId, stickerId] = String(key || '').split(':');
    const pack = STICKER_PACKS.find(p => p.id === packId);
    const sticker = pack?.stickers.find(s => s.id === stickerId);
    if (!sticker) return null;
    return { ...sticker, packId, packTitle: pack.title };
};

export const isStickerKey = key => Boolean(findSticker(key));
